export const LOGINPAGE = 'loginPage';
export const TFAPAGE = 'twoFactorPage';
export const FPASSPAGE = 'forgotPasswordPage';
export const RPASSPAGE = 'resetPasswordPage';
